import {
    Box, TextField, Button, Typography, ThemeProvider, createTheme,
    Select, MenuItem, InputLabel, FormControl, Popover, IconButton
} from '@mui/material';
import React, { useRef, useState } from 'react';
import { regionOptions, styleOptions } from '../data/TravelOptions';
import '../Pages/Profile.css';
import UploadField from './UploadImageComponenet';
import Swal from 'sweetalert2';
import CloseIcon from "@mui/icons-material/Close";
import DatePickerCalendar from './DatePickerCalendar';
import { shortRegionOptions } from '../data/TravelOptions';
import { Checkbox, FormControlLabel } from '@mui/material';

const uploadImageToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "profilePics");
    formData.append("cloud_name", "dyjdd8hcc");

    const response = await fetch("https://api.cloudinary.com/v1_1/dyjdd8hcc/image/upload", {
        method: "POST",
        body: formData,
    });

    const data = await response.json();
    return data.secure_url;
};

const EditUserProfile = ({ editedProfile, onExit, onSave }) => {

    const [profile, setProfile] = useState(editedProfile);
    const profileImage = useRef(null);

    const theme = createTheme({
        direction: 'rtl',
        typography: {
            fontFamily: 'Varela Round, sans-serif',
        },
    });

    const handleChange = (field, value) => {
        setProfile(prev => ({
            ...prev,
            [field]: value
        }));

        editedProfile = profile;
    };

    return (<ThemeProvider theme={theme}>
        <Box className="modal-overlay-profile">
            <Box className="modal-content-profile">
                <button className="close-button-profile" onClick={onExit}>✖</button>
                <Typography variant="h5" className="edit-profile-heading">
                    עריכת הפרופיל
                </Typography>

                <UploadField
                    label="תמונת פרופיל"
                    placeholder="העלאת תמונת פרופיל"
                    onFileSelect={(file) => {
                        profileImage.current = file;
                        const previewUrl = URL.createObjectURL(file);
                        setProfile(prev => ({ ...prev, previewImage: previewUrl }));
                    }}
                />
                {profile.previewImage && (
                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                        <img src={profile.previewImage} alt="תצוגה מקדימה" style={{ width: 150, height: 150, borderRadius: '50%', objectFit: 'cover' }} />
                    </Box>
                )}

                <TextField
                    fullWidth
                    margin="normal"
                    label="שם"
                    value={profile.title}
                    onChange={(e) => handleChange('title', e.target.value)}
                    inputProps={{ dir: 'rtl' }}
                />

                <TextField
                    fullWidth
                    margin="normal"
                    label="מקום מגורים"
                    value={profile.location}
                    onChange={(e) => handleChange('location', e.target.value)}
                    inputProps={{ dir: 'rtl' }}
                />

                <DatePickerCalendar
                    value={profile.birthDate}
                    onChange={(date) => handleChange('birthDate', date)}
                    label="תאריך לידה"
                    disablePortal
                />

                <TextField
                    fullWidth
                    margin="normal"
                    label="כדאי לטייל איתי כי"
                    value={profile.travelPitch || ''}
                    onChange={(e) => handleChange('travelPitch', e.target.value)}
                    inputProps={{ dir: 'rtl', maxLength: 60 }}
                    helperText="עד 5 מילים"
                />


                <TextField
                    fullWidth
                    margin="normal"
                    label="תחומי עניין"
                    value={profile.interests}
                    onChange={(e) => handleChange('interests', e.target.value)}
                    inputProps={{ dir: 'rtl' }}
                />

                <FormControl component="fieldset" fullWidth margin="normal">
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>אני אוהב/ת לטייל באזורים...</Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: 2 }}>
                        {shortRegionOptions.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                control={
                                    <Checkbox
                                        checked={profile.favorite_trip_locations.includes(option.label)}
                                        onChange={(e) => {
                                            const newValue = e.target.checked
                                                ? [...profile.favorite_trip_locations, option.label]
                                                : profile.favorite_trip_locations.filter(val => val !== option.label);
                                            handleChange('favorite_trip_locations', newValue); // או setFormData אם זה בקובץ של ההרשמה
                                        }}
                                    />
                                }
                                label={option.label}
                            />
                        ))}
                    </Box>
                </FormControl>



                <FormControl fullWidth margin="normal">
                    <InputLabel id="trip-style-label">סגנון טיול אהוב</InputLabel>
                    <Select
                        labelId="trip-style-label"
                        label="סגנון טיול אהוב"
                        multiple
                        value={profile.favorite_trip_styles}
                        onChange={(e) => handleChange('favorite_trip_styles', e.target.value)}
                        inputProps={{ dir: 'rtl' }}
                        MenuProps={{ PaperProps: { dir: 'rtl' } }}
                    >
                        {styleOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField
                    fullWidth
                    margin="normal"
                    label="קצת עליי"
                    multiline
                    rows={3}
                    value={profile.about}
                    onChange={(e) => handleChange('about', e.target.value)}
                    inputProps={{ dir: 'rtl' }}
                />

                <UploadField
                    label="העלאת תמונות מטיולי עבר"
                    placeholder="בחרי תמונה"
                    onFileSelect={async (file) => {
                        if (!file) return;

                        try {
                            const uploadedUrl = await uploadImageToCloudinary(file);
                            setProfile(prev => ({
                                ...prev,
                                tripPhotos: [
                                    ...(prev.tripPhotos || []),
                                    uploadedUrl
                                ]
                            }));
                            Swal.fire("התמונה נוספה!", "", "success");
                        } catch (error) {
                            console.error("שגיאה בהעלאת תמונה", error);
                            Swal.fire("שגיאה בהעלאת תמונה", "", "error");
                        }
                    }}
                />

                {profile.tripPhotos?.length > 0 && (
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
                            gap: 8,
                            mt: 2
                        }}
                    >
                        {profile.tripPhotos.map((url, idx) => (
                            <div key={idx} style={{ position: 'relative' }}>
                                <img
                                    src={url}
                                    alt={`טיול ${idx + 1}`}
                                    className="trip-photo-thumb"
                                />
                                <IconButton
                                    onClick={() => {
                                        setProfile(prev => ({
                                            ...prev,
                                            tripPhotos: prev.tripPhotos.filter((_, i) => i !== idx)
                                        }));
                                    }}
                                    sx={{
                                        position: "absolute",
                                        top: -6,
                                        right: -6,
                                        zIndex: 10,
                                        backgroundColor: "white",
                                        border: "1px solid #ccc",
                                        borderRadius: "50%",
                                        padding: "4px",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                        width: "24px",
                                        height: "24px"
                                    }}
                                >
                                    <CloseIcon sx={{ fontSize: "16px" }} />
                                </IconButton>
                            </div>
                        ))}
                    </Box>
                )}

                <Button className="save-profile-button"
                    variant="contained"
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={() => onSave(profile, profileImage)}
                >
                    שמירת שינויים
                </Button>
            </Box>
        </Box>
    </ThemeProvider>);
};

export default EditUserProfile;
